import { FC } from "react";
import styles from "./ReviewTextBlock.module.css";
import { Answer, Photo, Video } from "@types";
import FormattedAnswer from "./FormattedAnswer";
import { MediaGallery } from "@components/MediaGallery/MediaGallery";

import {
  PlusIcon,
  MinusIcon,
  RecommendIcon,
  NotRecommendIcon,
} from "../Icons/Icons";

interface ReviewTextBlockProps {
  comment: string;
  advantages?: string;
  disadvantages?: string;
  recommends?: boolean;
  answer?: Answer;
  photos?: Photo[];
  videos?: Video[];
}

export const ReviewTextBlock: FC<ReviewTextBlockProps> = ({
  comment,
  advantages = [],
  disadvantages = [],
  recommends = undefined,
  answer,
  photos = [],
  videos = [],
}) => {
  const showRecommendation = recommends !== undefined;

  // Проверка, что photos и videos являются массивами
  const validPhotos = Array.isArray(photos) ? photos : [];
  const validVideos = Array.isArray(videos) ? videos : [];

  // Дополнительная проверка на валидность объектов
  const filteredPhotos = validPhotos.filter((photo) => photo && photo.url);
  const filteredVideos = validVideos.filter((video) => video && video.url);

  const hasFilteredMedia =
    filteredPhotos.length > 0 || filteredVideos.length > 0;

  return (
    <div className={styles.reviewTextBlock}>
      {advantages.length > 0 && (
        <div className={styles.pointsSection}>
          <PlusIcon />
          <p className={styles.pointsText}>{advantages}</p>
        </div>
      )}

      {disadvantages.length > 0 && (
        <div className={styles.pointsSection}>
          <MinusIcon />
          <p className={styles.pointsText}>{disadvantages}</p>
        </div>
      )}

      <div className={styles.commentSection}>
        <p className={styles.mainComment}>{comment}</p>
      </div>

      {showRecommendation && (
        <div className={styles.recommendationSection}>
          {recommends ? <RecommendIcon /> : <NotRecommendIcon />}
          <p className={styles.pointsText}>
            {recommends
              ? "Я рекомендую этот товар"
              : "Я не рекомендую этот товар"}
          </p>
        </div>
      )}

      {hasFilteredMedia && (
        <MediaGallery photos={filteredPhotos} videos={filteredVideos} />
      )}

      {answer && (
        <div className={styles.answerSection}>
          <div className={styles.answerHeader}>
            <span className={styles.answerAuthor}>{answer.author}</span>
            <span className={styles.answerDate}>
              {new Date(answer.date).toLocaleDateString()}
            </span>
          </div>
          <FormattedAnswer text={answer.text} />
        </div>
      )}
    </div>
  );
};
